module.exports = __webpack_public_path__ + "img/dribble.565978d6.png";